import type {RefObject} from 'react'
import type {SwiperClass} from 'swiper/react'
import {Navigation} from './Navigation'
import {NavigationSeparators} from './Separators'

const GRID_ROWS_NAVIGATION = 'grid-rows-[64px_40px] md:grid-rows-[80px_38px] lg:grid-rows-[80px_80px]'

const GRID_COLS_NAVIGATION =
  'grid-cols-[20px_auto_20px] md:grid-cols-[60px_24px_auto_24px_60px] lg:grid-cols-[auto_24px_minmax(auto,1152px)_24px_auto]'

export const GridNavigation = ({
  swiperInstance,
  activeIndex,
  elements,
  progressBarRef,
  isDarkMode,
}: {
  swiperInstance: SwiperClass | null
  activeIndex: number
  elements: number
  progressBarRef: RefObject<HTMLDivElement>
  isDarkMode: boolean
}) => (
  <div className={`grid ${GRID_ROWS_NAVIGATION} ${GRID_COLS_NAVIGATION} ml-[-1px] w-full`}>
    <NavigationSeparators />
    <div className="col-span-1 col-start-2 row-span-1 row-start-1 ml-[-1px] mt-[-1px] flex items-center justify-center rounded-[4px] border-[1px] border-[#345142] md:col-start-3">
      <Navigation
        swiperInstance={swiperInstance}
        activeIndex={activeIndex}
        elements={elements}
        progressBarRef={progressBarRef}
        isDarkMode={isDarkMode}
      />
    </div>
  </div>
)
